import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=690e97c2"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690e97c2')) {
      api.createRecord('690e97c2', component.options)
    } else {
      api.reload('690e97c2', component.options)
    }
    module.hot.accept("./FormSection.vue?vue&type=template&id=690e97c2", function () {
      api.rerender('690e97c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/FormSection.vue"
export default component.exports